import { Reducer } from 'redux'
import { RootReducerType } from './index';

export const sessionReducer: Reducer<any, any> = (state = { updateTimerFlag: false }, action) => {
    switch (action.type) {
        case 'updateTimer':
            return { ...state, updateTimerFlag: true }
        case 'timerUpdated':
            return { ...state, updateTimerFlag: false }
        case 'removeTimer':
            return { ...state, removeTimer: true }
            default:
            return state
    }
}

export const sessionSelector = (state: RootReducerType) => state.session

export default sessionReducer